import { SAVED_GET, CLEAR_SAVED, RESET_STORE } from '../actions/types';

const INTIAL_STATE = {
  saved: [],
};

export default (state = INTIAL_STATE, action) => {
  switch (action.type) {
    case SAVED_GET:
      return {
        ...state,
        saved: [...state.saved, ...action.payload]
      };
    case CLEAR_SAVED:
      return {
        ...state,
        saved: []
      };
    case RESET_STORE:
      return {
        ...INTIAL_STATE,
      }
    default:
      return state;
  }
};
